// extracted by mini-css-extract-plugin
module.exports = {"modal-footer":"modal-footer_modal-footer__12LZ_"};